import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-33bc47ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "title" };
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        title: { default: "" },
        deep: { type: Boolean, default: false },
        backgroundColor: { default: "" },
        paddingBottom: { type: Boolean, default: true },
        border: { type: Boolean, default: true },
        shadow: { type: Boolean, default: false },
        size: { default: "defult" },
        type: { default: "defult" }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["cloud-card", [
                        {
                            'has-title': __props.title,
                            'is-deep': __props.deep,
                            'is-padding-bottom': !__props.paddingBottom,
                            'no-border': !__props.border,
                            'is-box-shadow': __props.shadow
                        },
                        'cloud-card-' + __props.size,
                        'cloud-card-type-' + __props.type
                    ]]),
                style: _normalizeStyle({ 'background-color': __props.backgroundColor })
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "title", {}, () => [
                        _createTextVNode(_toDisplayString(__props.title), 1)
                    ])
                ]),
                _renderSlot(_ctx.$slots, "default")
            ], 6));
        };
    }
});
